import { render, staticRenderFns } from "./prodotto.vue?vue&type=template&id=f20d0cbe"
import script from "./prodotto.vue?vue&type=script&lang=js"
export * from "./prodotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports